import { Component } from '@angular/core';

@Component({
  selector: '[app-sdp-footer]',
  templateUrl: './sdp-footer.component.html',
  styleUrls: ['./sdp-footer.component.css']
})
export class SdpFooterComponent {

}
